import type { GradeMappingSchema } from '@repo/schemas/grade-scale/gradeScale';

import { cn } from '@repo/lib/cn';

import type { GradeBand } from './gradeScale.types';

import { GradeBandBar } from './GradeBandBar';
import { getMappingBands } from './gradeScaleBands';

export interface GradeMappingPreviewProps {
  gradeMapping: GradeMappingSchema | null | undefined;
  /** Draws a vertical marker with its value at this percent along the bar. */
  markPercent?: number;
  /** When set, the marker becomes draggable and reports the picked percent. */
  onMarkChange?: (percent: number) => void;
  className?: string;
}

/** Summary of a grade mapping, or a placeholder when grading is off. */
export function GradeMappingPreview(gradeMappingPreviewProps: GradeMappingPreviewProps) {
  const { gradeMapping, markPercent, onMarkChange, className } = gradeMappingPreviewProps;

  const bands: GradeBand[] | null = getMappingBands(gradeMapping);

  if (!bands) {
    return <p className={cn('text-muted-foreground text-sm', className)}>Bez oceniania</p>;
  }

  return <GradeBandBar bands={bands} markPercent={markPercent} onMarkChange={onMarkChange} className={className} />;
}
